import type { InjectionKey } from 'vue';
import type { PagerInput } from '@/generated/graphql';
import i18n from '@/i18n';

export const translatorKey = Symbol('translation-key') as InjectionKey<(typeof i18n)['global']['t']>;

export const canAccessKey = Symbol('can-access-key') as InjectionKey<(key: string) => boolean>;

export const capitalizeKey = Symbol('capitalize-key') as InjectionKey<(key: string) => string>;

export const formatDateAddedKey = Symbol('format-date-added-key') as InjectionKey<
  (dbDateTime: string | number | Date) => { name: string; helped: string; date: Date }
>;

export const pagerKey = Symbol('pager-key') as InjectionKey<PagerInput>;
